import { render, staticRenderFns } from "./ren-process-detail.vue?vue&type=template&id=86f282c6&scoped=true&"
import script from "./ren-process-detail.vue?vue&type=script&lang=js&"
export * from "./ren-process-detail.vue?vue&type=script&lang=js&"
import style0 from "./ren-process-detail.vue?vue&type=style&index=0&id=86f282c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f282c6",
  null
  
)

export default component.exports